'use client';


/** Imports */
import React from 'react';
import Link from 'next/link';
import {useLocale} from 'next-intl';


/** Types */
type ExternalLinkProps = Readonly<
    Omit<React.ComponentPropsWithoutRef<'a'>, 'href'> & {
    href: string;
}>;


/** Component */
export default function ExternalLink(props: ExternalLinkProps) {
    const {href, children, ...anchorProps} = props;


    // Hooks
    const locale = useLocale();


    // Render
    return (
        <Link
            {...anchorProps}
            href={`/${locale}/leaving?target=${encodeURIComponent(href)}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {children}
        </Link>
    );
}
